import axios from 'axios';
import SecureAxiosClient from '../auth/secure_axios'
import getConfig from '../config';
const config = getConfig();

export const followUser = async (followData) => {
  const followUserUrl = `${config.daisy.domain}${config.daisy.services.follow_user}`;
  console.log("Follow User User:", followUserUrl);
  const response = await new SecureAxiosClient(true).putWithoutCallback(
    followUserUrl,
    followData
  );
  console.log("Follow response:", response);
  return response;
}

export const isFollowingUser = async (userId, followeeId) => {
  const followUserUrl = `${config.daisy.domain}${config.daisy.services.is_following_user}/${userId}/${followeeId}`;
  const response = await new SecureAxiosClient(true).get(
    followUserUrl
  );
  return response;
}